"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailToolbar = exports.useStyles = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const Refresh_1 = __importDefault(require("@material-ui/icons/Refresh"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Share_1 = __importDefault(require("@material-ui/icons/Share"));
const PlaylistAddCheck_1 = __importDefault(require("@material-ui/icons/PlaylistAddCheck"));
const AddBoxOutlined_1 = __importDefault(require("@material-ui/icons/AddBoxOutlined"));
const EditOutlined_1 = __importDefault(require("@material-ui/icons/EditOutlined"));
const DeleteOutlined_1 = __importDefault(require("@material-ui/icons/DeleteOutlined"));
const Save_1 = __importDefault(require("@material-ui/icons/Save"));
const Undo_1 = __importDefault(require("@material-ui/icons/Undo"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const confirm_dialog_1 = require("../confirm-dialog/confirm-dialog");
const share_dialog_1 = require("../share-dialog/share-dialog");
const detail_toolbar_button_2_1 = require("./detail-toolbar-button-2");
const detail_context_1 = require("./detail-context");
const detail_types_1 = require("./detail-types");
const evidence_defaults_context_1 = require("../evidence-defaults/evidence-defaults-context");
exports.useStyles = makeStyles_1.default({
    header: {
        boxShadow: '0px 0px 10px #ccc',
        zIndex: 98,
    },
    title: {
        margin: 10,
        fontSize: 25,
        fontWeight: 500,
    },
    subTitle: {
        marginLeft: 30,
        fontSize: 16,
    },
    toolbarWrapper: {
        backgroundColor: '#fafafa',
        paddingLeft: 10,
        display: 'flex',
        flex: '0 0 auto',
        zIndex: 99,
    },
    actionbarWrapper: {
        backgroundColor: '#fafafa',
        padding: '6px 4px',
        display: 'flex',
        flex: '0 0 auto',
        width: '100%',
        overflowX: 'auto',
    },
});
function DetailToolbar({ title, subtitle, showBtn = lodash_1.stubTrue, disableBtn = lodash_1.stubFalse, ActionBar, Before, After, }) {
    var _a, _b;
    /**
     * Styles
     */
    const classes = exports.useStyles();
    const { mode, source, refresh, startNew, startEditing, cancelEditing, validate, del, save, } = react_1.useContext(detail_context_1.DetailContext);
    const defaults = react_1.useContext(evidence_defaults_context_1.EvidenceDefaultsContext);
    const DetailToolbarButtonComponent = (_a = defaults.ToolbarButtonComponent) !== null && _a !== void 0 ? _a : detail_toolbar_button_2_1.DetailToolbarButton;
    /**
     * Confirm deletion dialog / Share dialog.
     */
    const confirmDeleteDialog = react_1.useRef(null);
    const shareDeleteDialog = react_1.useRef(null);
    const handleDelete = event_callback_hook_1.useEventCallback(() => {
        var _a;
        (_a = confirmDeleteDialog.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const handleShare = event_callback_hook_1.useEventCallback(() => {
        var _a;
        (_a = shareDeleteDialog.current) === null || _a === void 0 ? void 0 : _a.open();
    });
    const handleNew = event_callback_hook_1.useEventCallback(() => {
        startNew();
    });
    const isModeNew = mode === detail_types_1.DetailMode.NEW;
    const isModeEdit = mode === detail_types_1.DetailMode.EDIT;
    const isModeNone = mode === detail_types_1.DetailMode.NONE;
    const isModeView = mode === detail_types_1.DetailMode.VIEW;
    const showNew = showBtn === null || showBtn === void 0 ? void 0 : showBtn('NEW');
    const disabledNew = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('NEW')) || isModeNew || isModeEdit;
    const showRefresh = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('REFRESH')) && !isModeNone;
    const disabledRefresh = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('REFRESH')) || !isModeView;
    const showShare = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('SHARE')) && !isModeNone;
    const disabledShare = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('SHARE')) || !isModeView;
    const showEdit = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('EDIT')) && !isModeNone;
    const disabledEdit = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('EDIT')) ||
        !isModeView ||
        ((_b = source.data) === null || _b === void 0 ? void 0 : _b.active) === false;
    const showCheck = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('CHECK')) && !isModeNone;
    const disabledCheck = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('CHECK')) || isModeNone || isModeView;
    const showSave = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('SAVE')) && !isModeNone;
    const disabledSave = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('SAVE')) || isModeNone || isModeView;
    const showClose = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('CLOSE')) && !isModeNone;
    const disabledClose = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('CLOSE')) || isModeNone || isModeView;
    const showRemove = (showBtn === null || showBtn === void 0 ? void 0 : showBtn('REMOVE')) && !isModeNone;
    const disabledRemove = (disableBtn === null || disableBtn === void 0 ? void 0 : disableBtn('REMOVE')) || !isModeView;
    const subtitleText = react_1.useMemo(() => {
        if (subtitle) {
            return subtitle(source === null || source === void 0 ? void 0 : source.data);
        }
        return '';
    }, [source.data]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.header },
            react_1.default.createElement(Typography_1.default, { variant: "h1", className: classes.title },
                title,
                " ",
                react_1.default.createElement("span", { className: classes.subTitle }, subtitleText)),
            react_1.default.createElement("div", { className: classes.toolbarWrapper },
                !!Before && react_1.default.createElement(Before, null),
                showNew && (react_1.default.createElement(DetailToolbarButtonComponent, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__NEW", defaultMessage: "Nov\u00FD" }), startIcon: react_1.default.createElement(AddBoxOutlined_1.default, null), disabled: disabledNew, onClick: handleNew, type: detail_types_1.DetailToolbarButtonType.PRIMARY })),
                showRefresh && (react_1.default.createElement(DetailToolbarButtonComponent, { startIcon: react_1.default.createElement(Refresh_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__REFRESH", defaultMessage: "Obnovit" }), disabled: disabledRefresh, onClick: refresh })),
                showShare && (react_1.default.createElement(DetailToolbarButtonComponent, { startIcon: react_1.default.createElement(Share_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__SHARE", defaultMessage: "Sd\u00EDlet" }), disabled: disabledShare, onClick: handleShare })),
                showEdit && (react_1.default.createElement(DetailToolbarButtonComponent, { startIcon: react_1.default.createElement(EditOutlined_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__EDIT", defaultMessage: "Upravit" }), disabled: disabledEdit, onClick: startEditing })),
                showCheck && (react_1.default.createElement(DetailToolbarButtonComponent, { startIcon: react_1.default.createElement(PlaylistAddCheck_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__CHECK", defaultMessage: "Kontrola" }), disabled: disabledCheck, onClick: () => validate() })),
                showSave && (react_1.default.createElement(DetailToolbarButtonComponent, { startIcon: react_1.default.createElement(Save_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__SAVE", defaultMessage: "Ulo\u017Eit" }), onClick: save, disabled: disabledSave, type: detail_types_1.DetailToolbarButtonType.PRIMARY })),
                showClose && (react_1.default.createElement(DetailToolbarButtonComponent, { startIcon: react_1.default.createElement(Undo_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__CLOSE", defaultMessage: "Zru\u0161it" }), disabled: disabledClose, onClick: cancelEditing })),
                showRemove && (react_1.default.createElement(DetailToolbarButtonComponent, { startIcon: react_1.default.createElement(DeleteOutlined_1.default, null), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__ACTIONBAR__REMOVE", defaultMessage: "Smazat" }), disabled: disabledRemove, onClick: handleDelete, type: detail_types_1.DetailToolbarButtonType.SECONDARY })),
                !!After && react_1.default.createElement(After, null)),
            !!ActionBar && (react_1.default.createElement("div", { className: classes.actionbarWrapper },
                react_1.default.createElement(ActionBar, null)))),
        react_1.default.createElement(confirm_dialog_1.ConfirmDialog, { ref: confirmDeleteDialog, onConfirm: del, onCancel: lodash_1.noop, title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__DIALOG_CONFIRM__TITLE", defaultMessage: "Varov\u00E1n\u00ED" }), text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__DETAIL__DIALOG_CONFIRM__TEXT", defaultMessage: "Opravdu chcete smazat z\u00E1znam?" }) }),
        react_1.default.createElement(share_dialog_1.ShareDialog, { ref: shareDeleteDialog, onCancel: lodash_1.noop })));
}
exports.DetailToolbar = DetailToolbar;
//# sourceMappingURL=detail-toolbar-2.js.map